import { Map as OlMap, View } from "ol";
import { defaults } from "ol/control/defaults";
import { fromLonLat } from "ol/proj";

export const MAP_OPTIONS = {
  ZOOM: {
    DEFAULT: 7,
    MIN: 7,
    MAX: 24,
  },
};

export const MapDefaultView = new View({
  zoom: MAP_OPTIONS.ZOOM.DEFAULT,
  minZoom: MAP_OPTIONS.ZOOM.MIN,
  maxZoom: MAP_OPTIONS.ZOOM.MAX,
  center: fromLonLat([126.9018, 37.5622]),
});

export const useInspectMap = () => {
  const initOlMap = (mapContainer: OlMap | null, view?: View) => {
    if (mapContainer) return;
    const mapObject = new OlMap({
      target: "map",
      controls: defaults({ zoom: false, rotate: false, attribution: false }),
      view: view ?? MapDefaultView,
    });
    mapContainer = mapObject;

    (window as any).map = mapObject;
    return mapObject;
  };

  return {
    initOlMap,
  };
};
